// @ts-strict-ignore
import * as React from 'react';
import { SvgIconReact } from 'common/components/svg-icon';
import styles from './chart-preview.module.styl';
type CarouselProps = {
  pauseRotation?: boolean;
  children: Array<React.ReactNode>;
};
export const ChartPreviewCarousel = (_ref: CarouselProps) => {
  let {
    pauseRotation,
    children
  }: CarouselProps = _ref;
  const [activePreview, setActivePreview] = React.useState(0);
  const timerRef = React.useRef(null);
  const hasUserSelect = React.useRef(false);
  React.useEffect(() => {
    if (!pauseRotation && hasUserSelect.current === false) {
      const timerId = setTimeout(() => {
        setActivePreview((activePreview + 1) % children.length);
      }, 7000);
      timerRef.current = timerId;
    }
    return () => {
      clearInterval(timerRef.current);
    };
  }, [activePreview, pauseRotation]);
  return <div className={styles.chartPreviewContainer} data-sentry-component="ChartPreviewCarousel" data-sentry-source-file="chart-preview-carousel.tsx">
      <div style={{
      width: "100%",
      maxWidth: "420px",
      height: "280px"
    }} className={styles.chartAnimation} key={activePreview}>
        {children[activePreview]}
      </div>
      <div className={styles.dial}>
        {children.map((_, ind) => {
        return <SvgIconReact key={ind} icon={"status-light"} color={ind === activePreview ? "#4F44E0" : "#e5e5e6"} onClick={() => {
          setActivePreview(ind);
          clearInterval(timerRef.current);
          hasUserSelect.current = true;
        }} />;
      })}
      </div>
    </div>;
};